var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1 2 L 2 1 L 24 23 L 23 24 L 1 2 M 24 2 L 2 24 L 1 23 L 23 1 L 24 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseButton);
export default __webpack_public_path__ + "static/media/icon--close-button.e3787ec4ca472e30798917cf5ca6913c.svg";
export { ForwardRef as ReactComponent };